import { useEffect, useRef, useState } from 'react';
import {MakerDialog} from './maker-dialog'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { carTypes, carYears, CategoryMaker, prefectures, Maker, ModalContext, timeSlots } from './model'
import { Alert, CircularProgress, IconButton, Snackbar } from '@mui/material';

const steps = ['お車情報', 'お客様情報', '完了']

export function HeroRight({makerstring, categorystring, step, logged}: {logged: boolean, step: number, makerstring: string, categorystring: string}) {
  const [activeStep, setActiveStep] = useState(step)
  const makers: [Maker] = makerstring ? JSON.parse(makerstring) : []
  const [selectedMaker, setSelectedMaker] = useState<Maker|null>(null)
  const categoryMakers: [CategoryMaker] = categorystring ? JSON.parse(categorystring) : []
  const freeRibbon = new URL('../img/free-ribbon.png', import.meta.url)
  const [loading, setLoading] = useState(false)

  const [files, setFiles] = useState<File[]>([])
  const [type, setType] = useState('')
  const [model, setModel] = useState('')
  const [grade, setGrade] = useState('')
  const [displacement, setDisplacement] = useState('')
  const [mileage, setMileage] = useState<number>()
  const [history, setHistory] = useState("");
  const [inspection, setInspection] = useState('')
  const [transmission, setTransmission] = useState('')
  const [loanBalance, setLoanBalance] = useState('')
  const [modelYear, setYear] = useState('')
  const [appealPoint, setAppealPoint] = useState('')
  const [timeSlot, setTimeSlot] = useState('')

  const [name1, setName1] = useState('')
  const [name2, setName2] = useState('')
  const [postal_code, setPostalCode] = useState('')
  const [prefecture, setPrefecture] = useState('')
  const [city, setCity] = useState('')
  const [phone, setPhone] = useState('')
  const [email1, setEmail1] = useState('')
  const [email2, setEmail2] = useState('')
  const [password1, setPassword1] = useState('')
  const [password2, setPassword2] = useState('')

  const [openMakerDialog, setOpenMakerDialog] = useState(false)
  const [showRequired, setShowRequired] = useState(false)

  const [errorMessage, setErrorMessage] = useState('')

  const containerRef = useRef<HTMLDivElement | null>(null)
  const modelRef = useRef<HTMLInputElement | null>(null)
  const typeRef = useRef<HTMLInputElement | null>(null)
  const mileageRef = useRef<HTMLInputElement | null>(null)
  const modelYearRef = useRef<HTMLInputElement | null>(null)
  const timeSlotRef = useRef<HTMLInputElement | null>(null)
  const name1Ref = useRef<HTMLInputElement | null>(null)
  const name2Ref = useRef<HTMLInputElement | null>(null)
  const postalCodeRef = useRef<HTMLInputElement | null>(null)
  const prefectureRef = useRef<HTMLInputElement | null>(null)
  const cityRef = useRef<HTMLInputElement | null>(null)
  const phoneRef = useRef<HTMLInputElement | null>(null)
  const email1Ref = useRef<HTMLInputElement | null>(null)
  const email2Ref = useRef<HTMLInputElement | null>(null)
  const password1Ref = useRef<HTMLInputElement | null>(null)
  const password2Ref = useRef<HTMLInputElement | null>(null)
  
  function submitProduct() {
    setLoading(true)
    const body = new FormData()    
    body.append('action', 'submit_product')
    for (let i = 0; i < files.length; i++) {
      body.append('files[]', files[i])
    }
    body.append('maker', selectedMaker!.title)
    body.append('type', type)
    body.append('model', model)
    body.append('grade', grade)
    body.append('displacement', displacement)
    body.append('history', history)
    body.append('inspection', inspection)
    body.append('transmission', transmission)
    body.append('loanBalance', loanBalance)
    body.append('modelYear', modelYear)
    body.append('mileage', mileage!.toString())
    body.append('appealPoint', appealPoint)
    body.append('timeSlot', timeSlot)
    body.append('appealPoint', appealPoint)
    body.append('name1', name1)
    body.append('name2', name2)
    body.append('email1', email1)
    body.append('password1', password1)
    body.append('postal_code', postal_code)
    body.append('prefecture', prefecture)
    body.append('city', city)
    body.append('phone', phone)
    fetch('/wp-admin/admin-ajax.php', {
      method: "POST",
      body
    })
    .then(res => res.json())
    .then(res => {
      setLoading(false)
      if (res.success) {
        sessionStorage.clear()
        setActiveStep(2)
      } else {
        setErrorMessage(res.data.message)
      }
    })
    .catch(err => {
      setLoading(false)
      setErrorMessage(err.message)
    })
  }
  function submitForm(logged: boolean) {
    setLoading(true)
    const body = new FormData()
    if (selectedMaker?.title) {
      body.append('car[meka]', selectedMaker.title)
    }
    if (appealPoint) {
      body.append('car[description]', appealPoint)
    }
    if (type) {
      body.append('car[type]', type)
    }
    if (model) {
      body.append('car[model]', model)
    }
    if (grade) {
      body.append('car[grade]', grade)
    }
    if (displacement) {
      body.append('car[displacement]', displacement)  
    }
    if (mileage) {
      body.append('car[route]', mileage!.toString())
    }
    if (history) {
      body.append('car-repair-check', history)
    }
    if (inspection) {
      body.append('car[check]', inspection)
    }
    if (transmission) {
      body.append('car-transmission', transmission)
    }
    if (loanBalance) {
      body.append('car-loan', loanBalance)
    }
    if (modelYear) {
      body.append('car[year]', modelYear)
    }
    if (timeSlot) {
      body.append('car[contact_time]', timeSlot)
    }
    if (name1) {
      body.append('user[name]', name1)
    }
    if (name2) {
      body.append('user[name_kana]', name2)
    }
    if (postal_code) {
      body.append('user[postcode]', postal_code)
    }
    if (prefecture) {
      body.append('user[pref]', prefecture)
    }
    if (city) {
      body.append('user[city]', city)
    }
    if (phone) {
      body.append('user[phone]', phone)
    }
    if (email1) {
      body.append('user[email]', email1)
    }
    if (email2) {
      body.append('user[email_confirm]', email2)
    }
    if (password1) {
      body.append('user[password]', password1)
    }
    if (password2) {
      body.append('user[password_confirmed]', password2)
    }
    for (let i = 0; i < files.length; i++) {
      body.append('mfile-upload[]', files[i])
    }
    console.log('--- FormDataの内容 (手動構築) ---');
    for (let [key, value] of body.entries()) {
      console.log(`${key}:`, value);
    }
    console.log('--------------------');

    fetch('https://sv.ra-kune.com/api/contact', { method: "POST", body })
    .then(async res => {
      const data = await res.json()

      if (!res.ok) {
        // HTTP-level error (400, 500, etc.)
        setLoading(false)
        setErrorMessage(data.errors ? JSON.stringify(data.errors) : data.message || `Error ${res.status}`)
        return
      }

      // Application-level check
      if (!data.errors) {
        submitProduct()
      } else {
        setLoading(false)
        setErrorMessage(JSON.stringify(data.errors))
      }
    })
    .catch(err => {
      setLoading(false);
      setErrorMessage(err.message);
    });
  }
  function saveStep0() {
    if (!selectedMaker) {
      setOpenMakerDialog(true)
      return false
    }
    if (!type) {
      setShowRequired(true)
      setErrorMessage('「車種」を入力してください。')
      return false
    }
    if (!model) {
      setShowRequired(true)
      typeRef.current?.scrollIntoView({ behavior: 'smooth' })
      setErrorMessage('「型式」を入力してください。')
      return false
    }
    if (!mileage) {
      setShowRequired(true)
      mileageRef.current?.scrollIntoView({ behavior: 'smooth' })
      setErrorMessage('「走行距離量」を入力してください。')
      return false
    }

    if (files.length > 0) {
      Promise.all(
        files.map(
          (file) =>
            new Promise<string>((resolve) => {
              const reader = new FileReader()
              reader.onload = () => resolve(reader.result as string)
              reader.readAsDataURL(file)
            })
        )
      ).then((base64Files) => {
        sessionStorage.setItem("files", JSON.stringify(base64Files))
      })
    }    
    sessionStorage.setItem('maker', selectedMaker.id.toString())
    sessionStorage.setItem('model', model)
    sessionStorage.setItem('type', type)
    sessionStorage.setItem('mileage', mileage.toString())
    return true
  }
  function saveStep1() {
    if (!modelYear || !timeSlot) {
      setShowRequired(true)
      return false
    }
    sessionStorage.setItem('displacement', displacement)
    sessionStorage.setItem('history', history)
    sessionStorage.setItem('inspection', inspection)
    sessionStorage.setItem('transmission', transmission)
    sessionStorage.setItem('loanBalance', loanBalance)
    sessionStorage.setItem('modelYear', modelYear)
    sessionStorage.setItem('appealPoint', appealPoint)
    sessionStorage.setItem('timeSlot', timeSlot)
    sessionStorage.setItem('grade', grade)
    return true
  }
  function saveStep2() {
    if (!name1 || !name1 || !postal_code || !prefecture || !city || !phone || !email1 || !email2 || !password1 || password1.length < 6 || !password2 || password1 !== password2) {
      setShowRequired(true)
      return false
    }
    sessionStorage.setItem('name1', name1)
    sessionStorage.setItem('name2', name2)
    sessionStorage.setItem('prefecture', prefecture)
    sessionStorage.setItem('city', city)
    sessionStorage.setItem('phone', phone)
    sessionStorage.setItem('postal_code', postal_code)
    sessionStorage.setItem('email1', email1)
    sessionStorage.setItem('password1', password1)
    return true
  }
  function handleStep2() {
    if (!saveStep2()) {
      if (!name1) {
        name1Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「氏名」を入力してください。')
        return
      }
      if (!name2) {
        name2Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「氏名（フリガナ)」を入力してください。')
        return
      }
      if (!postal_code || !/^\d{7}$/.test(postal_code)) {
        postalCodeRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('正確な「郵便番号」を入力してください。')
        return
      }
      if (!prefecture) {
        prefectureRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「都道府県」を入力してください。')
        return
      }
      if (!city) {
        cityRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「市区町村」を入力してください。')
        return
      }
      if (!phone || !/^\d{10,11}$/.test(phone)) {
        phoneRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('正確な「電話番号」を入力してください。')
        return
      }
      if (!email1 || !/^\S+@\S+\.\S+$/.test(email1)) {
        email1Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('正確な「メールアドレス」を入力してください。')
        return
      }
      if (!email2) {
        email2Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「メールアドレス確認」が一致しません。')
        return
      }
      if (!password1 || password1.length < 6) {
        password1Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「パスワード(6文字以上)」を入力してください。')
        return
      }
      if (!password2 || password1 !== password2) {
        password2Ref.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「パスワード確認」が一致しません。')
        return
      }
      containerRef.current?.scrollIntoView({ behavior: 'smooth' })
      return
    }
    submitForm(false)
    // submitProduct()
  }
  function handleStep1() {
    if (!saveStep0()) {
      return
    }
    if (!saveStep1()) {
      if (!mileage) {
        mileageRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「走行距離量」を入力してください。')
        return
      }
      if (!timeSlot) {
        timeSlotRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「連絡希望時間帯」を入力してください。')
        return
      }
      if (!modelYear) {
        modelYearRef.current?.scrollIntoView({ behavior: 'smooth' })
        setErrorMessage('「年式」を入力してください。')
        return
      }
      return
    }
    setShowRequired(false)
    if (logged) {
      submitForm(true)
    } else {
      setShowRequired(false)
      setActiveStep(1)
    }
  }
  function handleStep0() {
    if (loading) {
      return
    }
    if (!saveStep0()) {
      // if (selectedMaker && !model) {
      //   modelRef.current?.scrollIntoView({ behavior: 'smooth' })
      //   return
      // }
      return
    }
    setLoading(true)
    window.location.href = '/sell'
  }
  useEffect(() => {
    const saved = sessionStorage.getItem("files");
    if (saved) {
      const base64Files: string[] = JSON.parse(saved);
      Promise.all(
        base64Files.map(async (base64, index) => {
          const res = await fetch(base64);
          const blob = await res.blob();
          let ext = "";
          if (blob.type === "image/jpeg") ext = "jpg";
          else if (blob.type === "image/png") ext = "png";
          else throw new Error(`Unsupported file type: ${blob.type}`);
          return new File([blob], `restored-file-${index + 1}.${ext}`, {type: blob.type})
        })
      ).then((restoredFiles) => setFiles(restoredFiles));
    }
    const makerId = sessionStorage.getItem('maker')
    if (makerId && makers.length > 0) {
      makers.map((maker: Maker) => {
        if (maker.id.toString() === makerId) {
          setSelectedMaker(maker)
        }
      })
    }
    const mileage = sessionStorage.getItem('mileage')
    if (mileage) {
      setMileage(Number(mileage))
    }
    const type = sessionStorage.getItem('type')
    if (type) {
      setType(type)
    }
    const model = sessionStorage.getItem('model')
    if (model) {
      setModel(model)
    }
    const grade = sessionStorage.getItem('grade')
    if (grade) {
      setGrade(grade)
    }
    const displacement = sessionStorage.getItem('displacement')
    if (displacement) {
      setDisplacement(displacement)
    }
    const history = sessionStorage.getItem('history')
    if (history) {
      setHistory(history)
    }
    const inspection = sessionStorage.getItem('inspection')
    if (inspection) {
      setInspection(inspection)
    }
    const transmission = sessionStorage.getItem('transmission')
    if (transmission) {
      setTransmission(transmission)
    }
    const loanBalance = sessionStorage.getItem('loanBalance')
    if (loanBalance) {
      setLoanBalance(loanBalance)
    }
    const modelYear = sessionStorage.getItem('modelYear')
    if (modelYear) {
      setYear(modelYear)
    }
    const appealPoint = sessionStorage.getItem('appealPoint')
    if (appealPoint) {
      setAppealPoint(appealPoint)
    }
    const timeSlot = sessionStorage.getItem('timeSlot')
    if (timeSlot) {
      setTimeSlot(timeSlot)
    }
    const name1 = sessionStorage.getItem('name1')
    if (name1) {
      setName1(name1)
    }
    const name2 = sessionStorage.getItem('name2')
    if (name2) {
      setName2(name2)
    }

    const post = sessionStorage.getItem('postal_code')
    if (post) {
      setPostalCode(post)
    }
    const prefecture = sessionStorage.getItem('prefecture')
    if (prefecture) {
      setPrefecture(prefecture)
    }
    const city = sessionStorage.getItem('city')
    if (city) {
      setCity(city)
    }
    const phone = sessionStorage.getItem('phone')
    if (phone) {
      setPhone(phone)
    }
    const email1 = sessionStorage.getItem('email1')
    if (email1) {
      setEmail1(email1)
    }
    const password1 = sessionStorage.getItem('password1')
    if (password1) {
      setPassword1(password1)
    }
  }, [])
  useEffect(() => {
    if (selectedMaker) {
      const type = sessionStorage.getItem('type')
      if (type) {
        let bFind = false
        const models = carTypes[selectedMaker.title]
        if (models) {
          for (const item of models) {
            if (typeof item === 'string') {
              if (item === type) {
                bFind = true
              }              
            } else {
              for (const key of Object.keys(item)) {
                for (const subItem of item[key]) {
                  if (subItem === type) {
                    bFind = true
                  }
                }
              }
            }
          }
        }
        if (bFind) {
          setType(type)          
        } else {
          sessionStorage.removeItem('type')
        }
      }
    }
  }, [selectedMaker])
  return (
    <ModalContext.Provider value={{openMakerDialog, setOpenMakerDialog, makers, categoryMakers, selectedMaker, setSelectedMaker}}>
      <div ref={containerRef} className='hero-right bg-white max-w1400:mx-auto w-auto sm:w-[540px] lg:min-h-[70vh] h-full rounded-2xl p-[20px] sm:p-[40px] flex flex-col justify-center gap-[20px] relative scroll-mt-[85px] sm:scroll-mt-[140px]'>
        <img src={freeRibbon.href} alt='' className='absolute top-[-20px] right-[-20px] w-[100px] object-contain' />
        {
          activeStep >= 0 &&
          <Stepper activeStep={activeStep} alternativeLabel>
            {
              steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))
            }
          </Stepper>
        }
        {
          activeStep >= 0 &&
          <div>
            <p className='text-[14px]'>こちらに車の写真をアップロードしてください</p>
            <div
              className='dropzone cursor-pointer mt-1 border border-dashed border-black rounded-md w-full h-[120px] relative flex items-center justify-center'
              onDragOver={(e) => e.preventDefault()}
              onDrop={event=>{
                event.preventDefault()
                const droppedFiles = Array.from(event.dataTransfer.files).slice(0, 5 - files.length)
                setFiles([...files, ...droppedFiles])
              }}
              onClick={() => document.getElementById('fileInput')?.click()}>
              <input
                id="fileInput"
                type="file"
                multiple
                accept="image/*"
                className="hidden"
                onChange={event=>{
                  if (!event.target.files) {
                    return
                  }
                  const selectedFiles = Array.from(event.target.files).slice(0, 5 - files.length)
                  setFiles([...files, ...selectedFiles])
                }}
              />

              {
              files.length == 0
              ?
                <div className='message text-center'>
                  <p className='text-[18px] font-bold'>ドラッグ＆ドロップでアップロード</p>
                  <p>お車の写真をアップロード</p>
                </div>
                :
                <div className="preview h-full grid grid-cols-5 gap-2 p-2">
                  {
                    files.map((file, index) =>
                      <div key={index} className="relative w-full rounded overflow-hidden">
                        <img
                          src={URL.createObjectURL(file)}
                          alt=""
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={(e) => {
                            e.stopPropagation()
                            const newFiles = [...files]
                            newFiles.splice(index, 1)
                            setFiles(newFiles)
                          }}
                          className="absolute top-1 right-1 bg-black text-white rounded-full w-4 h-4 text-xs flex items-center justify-center"
                        >
                          ×
                        </button>
                      </div>
                    )
                  }

                  {
                    files.length < 5 &&
                    <div
                      onClick={(e) => {
                        e.stopPropagation()
                        document.getElementById('fileInput')?.click()
                      }}
                      className="flex items-center justify-center w-full border border-dashed border-gray-400 rounded cursor-pointer text-2xl font-bold">
                      +
                    </div>
                  }
                </div>
              }
              <div className='counter absolute bottom-2 right-2 text-[14px]'>{files.length} of 5</div>
            </div>
          </div>
        }
        {
          activeStep < 1 &&
          <>

          <div>
            <p>メーカー<span className='requirep'>必須</span></p>
            <button
              onClick={() => setOpenMakerDialog(true)}
              className='cursor-pointer flex flex-row items-center justify-between mt-1 p-2 border border-black rounded-sm w-full'>
              {selectedMaker?.title || '選択してください'}
              <i className="fa-solid fa-chevron-down"></i>
            </button>
          </div>

          <div ref={modelRef} className='scroll-mt-[85px] sm:scroll-mt-[140px]'>
            <p>車種<span className='requirep'>必須</span></p>
            <div className='relative'>
              <select
                className={`appearance-none ${selectedMaker==null?'cursor-not-allowed':'cursor-pointer'} flex flex-row items-center justify-between mt-1 p-2 border ${showRequired&&!type?'border-red':'border-black'} rounded-sm w-full`}
                value={type}
                onChange={(e) => setType(e.target.value)}>
                <option value=''>選択してください</option>
                {selectedMaker && carTypes[selectedMaker.title]?.map((item, index) => {
                  if (typeof item === 'string') {
                    return <option key={item} value={item}>{item}</option>;
                  } else {
                    const entries = Object.keys(item).map(key => [key, (item as Record<string, string[]>)[key]]);
                    const [groupName, models] = entries[0] as [string, string[]];
                    return (
                      <optgroup key={groupName} label={groupName}>
                        {models.map(modelName => (
                          <option key={modelName} value={modelName}>{modelName}</option>
                        ))}
                      </optgroup>
                    );
                  }
                })}
              </select>
              <i className="fa-solid fa-chevron-down absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"></i>
            </div>
          </div>

          <div ref={typeRef} className='scroll-mt-[85px] sm:scroll-mt-[140px]'>
            <p>型式<span className='requirep'>必須</span></p>
            <input value={model} onChange={(e) => setModel(e.target.value)} placeholder='車の型式' className={`mt-1 p-2 border ${showRequired&&!model?'border-red':'border-black'} rounded-sm w-full`} />
          </div>
          <div ref={mileageRef} className='scroll-mt-[85px] sm:scroll-mt-[140px]'>
            <p>走行距離量(km)<span className='requirep'>必須</span></p>
            <input value={mileage} onChange={e=>{
              if (e.target.value) {
                setMileage(Number(e.target.value))
              } else {
                setMileage(0)
              }
            }} type='number' placeholder='これまでの走行距離' className={`mt-1 p-2 border ${showRequired&&!mileage?'border-red':'border-black'} rounded-sm w-full`} />
          </div>
          </>
        }
        {
          activeStep < 0
          ?
          <button
            onClick={handleStep0}
            className='cursor-pointer self-center bg-black text-white font-bold py-3 w-[200px] rounded-full'>
              {
                loading
                ?
                <CircularProgress size={'20px'} className='!text-white'/>
                :  
                <span><span className='rounded-full px-2 text-black bg-white mr-[40px]'>無料</span>次へ</span>
              }
          </button>
          :
          activeStep == 0
          ?
          <>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={modelYearRef}>
              <p>年式<span className='requirep'>必須</span></p>
              <div className='relative'>
                <select
                  className={`appearance-none cursor-pointer flex flex-row items-center justify-between mt-1 p-2 border ${showRequired&&!modelYear?'border-red':'border-black'} rounded-sm w-full`}
                  value={modelYear}
                  onChange={(e) => setYear(e.target.value)}>
                  <option value=''>選択してください</option>
                  {carYears.map((item, index) => {
                    return <option key={item} value={item}>{item}</option>;
                  })}
                </select>
                <i className="fa-solid fa-chevron-down absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"></i>
              </div>
            </div>
            <div>
              <p>連絡希望時間帯<span className='requirep'>必須</span></p>
              <div className='relative'>
                <select
                  className={`appearance-none cursor-pointer flex flex-row items-center justify-between mt-1 p-2 border ${showRequired&&!timeSlot?'border-red':'border-black'} rounded-sm w-full`}
                  value={timeSlot}
                  onChange={(e) => setTimeSlot(e.target.value)}
                >
                  <option value=''>選択してください</option>
                  {timeSlots.map((item, index) => {
                    return <option key={item} value={item}>{item}</option>;
                  })}
                </select>
                <i className="fa-solid fa-chevron-down absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"></i>
              </div>
            </div>
            <div>
              <p>グレード</p>
              <input value={grade} onChange={(e) => setGrade(e.target.value)} placeholder='グレード' className={`mt-1 p-2 border border-black rounded-sm w-full`} />
            </div>
            <div>
              <p>排気量</p>
              <input value={displacement} onChange={(e) => setDisplacement(e.target.value)} placeholder='排気量' className={`mt-1 p-2 border border-black rounded-sm w-full`} />
            </div>
            <div>
              <p>修復歴/交換歴</p>
              {["修復歴あり", "未修復", "事故歴あり", "事故歴なし"].map((option) => (
                <label key={option} className="block mb-2">
                  <input
                    type="radio"
                    name="carHistory"
                    value={option}
                    checked={history === option}
                    onChange={(e) => setHistory(e.target.value)}
                    className="mr-2"
                  />
                  {option}
                </label>
                ))}
            </div>
            <div>
              <p>車検</p>
              <input value={inspection} onChange={(e) => setInspection(e.target.value)} placeholder='車検の実施日程、次回の予定など' className={`mt-1 p-2 border border-black rounded-sm w-full`} />
            </div>
            <div>
              <p>トランスミッション</p>
              {["AT", "MT"].map((option) => (
                <label key={option} className="mr-4">
                  <input
                    type="radio"
                    name="carTransmission"
                    value={option}
                    checked={transmission === option}
                    onChange={(e) => setTransmission(e.target.value)}
                    className="mr-2"
                  />
                  {option}
                </label>
                ))}
            </div>
            <div>
              <p>ローン残高</p>
              {["有", "無"].map((option) => (
                <label key={option} className="mr-4">
                  <input
                    type="radio"
                    name="loanBalance"
                    value={option}
                    checked={loanBalance === option}
                    onChange={(e) => setLoanBalance(e.target.value)}
                    className="mr-2"
                  />
                  {option}
                </label>
                ))}
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={timeSlotRef}>
              <p>アピールポイント</p>
              <textarea rows={4} value={appealPoint} onChange={(e) => setAppealPoint(e.target.value)} placeholder='アピールポイントを入力してください。' className={`mt-1 p-2 border border-black rounded-sm w-full`}></textarea>
            </div>
            <button
              onClick={handleStep1}
              className='cursor-pointer self-center bg-black text-white font-bold py-3 w-[100px] rounded-full'>
              {
                loading
                ?
                <CircularProgress className='!text-white' size={20} />
                :
                <span>次へ</span>
              }
            </button>
          </>
          :
          activeStep == 1
          ?
          <>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={name1Ref}>
              <p>氏名<span className='requirep'>必須</span></p>
              <input value={name1} onChange={(e) => setName1(e.target.value)} placeholder='氏名' className={`mt-1 p-2 border ${showRequired&&!name1?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={name2Ref}>
              <p>{`氏名（フリガナ)`}<span className='requirep'>必須</span></p>
              <input value={name2} onChange={(e) => setName2(e.target.value)} placeholder='氏名（フリガナ)' className={`mt-1 p-2 border ${showRequired&&!name2?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={postalCodeRef}>
              <p>{`郵便番号`}<span className='requirep'>必須</span></p>
              <input value={postal_code} onChange={(e) => setPostalCode(e.target.value)} placeholder='郵便番号' className={`mt-1 p-2 border ${showRequired&&!postal_code?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={prefectureRef}>
              <p>都道府県<span className='requirep'>必須</span></p>
              <div className='relative'>
                <select
                  className={`appearance-none cursor-pointer flex flex-row items-center justify-between mt-1 p-2 border ${showRequired&&!prefecture?'border-red':'border-black'} rounded-sm w-full`}
                  value={prefecture}
                  onChange={e => {
                    setPrefecture(e.target.value)
                  }}>
                  <option value=''>選択してください</option>
                  {
                    prefectures.map(item => {
                      return <option key={item} value={item}>{item}</option>;
                    })
                  }
                </select>
                <i className="fa-solid fa-chevron-down absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"></i>
              </div>
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={cityRef}>
              <p>市区町村<span className='requirep'>必須</span></p>
              <input value={city} onChange={(e) => setCity(e.target.value)} placeholder='○○市○○区' className={`mt-1 p-2 border ${showRequired&&!city?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={phoneRef}>
              <p>電話番号<span className='requirep'>必須</span></p>
              <input type='tel' value={phone} onChange={(e) => setPhone(e.target.value)} placeholder='000-0000-000' className={`mt-1 p-2 border ${showRequired&&!phone?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={email1Ref}>
              <p>メールアドレス<span className='requirep'>必須</span></p>
              <input type='email' value={email1} onChange={(e) => setEmail1(e.target.value)} placeholder='example@example.com' className={`mt-1 p-2 border ${showRequired&&!email1?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={email2Ref}>
              <p>メールアドレス確認<span className='requirep'>必須</span></p>
              <input autoComplete='off' type='email' value={email2} onChange={(e) => setEmail2(e.target.value)} placeholder='確認のためもう一度' className={`mt-1 p-2 border ${showRequired&&!email2?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={password1Ref}>
              <p>パスワード<span className='requirep'>必須</span></p>
              <input autoComplete='new-password' type='password' value={password1} onChange={(e) => setPassword1(e.target.value)} placeholder='半角英数字6文字以上' className={`mt-1 p-2 border ${showRequired&&(!password1||password1.length<6)?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='scroll-mt-[85px] sm:scroll-mt-[140px]' ref={password2Ref}>
              <p>パスワード確認<span className='requirep'>必須</span></p>
              <input autoComplete='new-password' type='password' value={password2} onChange={(e) => setPassword2(e.target.value)} placeholder='確認のためもう一度' className={`mt-1 p-2 border ${showRequired&&(!password2||password2.length<6||password1!=password2)?'border-red':'border-black'} rounded-sm w-full`} />
            </div>
            <div className='mx-auto'>
              <p className='mt-4'><a className='underline'>利用規約</a>と<a className='underline'>個人情報の取り扱い</a>に同意の上お進みください。</p>
            </div>
            <div className='flex flex-row justify-around'>
              <button
                onClick={()=>setActiveStep(0)}
                className='cursor-pointer bg-white text-black font-bold py-2 w-[100px] border border-black rounded-full'>
                <span>前へ</span>
              </button>
              <button
                onClick={handleStep2}
                className='cursor-pointer bg-black text-white font-bold py-2 w-[100px] rounded-full flex flex-row items-center justify-center'>
                  {
                    loading
                    ?
                    <CircularProgress className='!text-white' size={20}/>
                    :
                    null
                  }
                次へ
              </button>
            </div>
          </>
          :
          activeStep === 2
          ?
          <div className='flex flex-col items-center'>
            <div className='text-lg sm:text-[24px] font-bold'>お申し込みありがとうございます</div>
            <div className='mt-4'>お申し込み完了メールをお送りしましたのでご確認ください。</div>
            <button
              onClick={()=>{
                window.location.href = '/'
              }}
              className='cursor-pointer bg-black text-white font-bold py-3 px-8 rounded-full mt-4'>
              トップページへ戻る
            </button>
          </div>
          :
          <></>
        }
        <MakerDialog/>
      <Snackbar
        open={errorMessage.length>0}
        autoHideDuration={6000}
        onClose={()=>setErrorMessage('')}
        message={errorMessage}
        anchorOrigin={{'horizontal': 'right', 'vertical': 'bottom'}}
      >
        <Alert onClose={()=>setErrorMessage('')} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      </div>
    </ModalContext.Provider>
  )
}
